import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { D as O, f as y } from "../../vendor--aJiswR_.js";
import { forwardRef as N, useState as v, useRef as I, useEffect as C } from "react";
import { BaseIcon as D } from "../BaseIcon/index.js";
import '../../assets/index19.css';const x = "_container_343hu_1", G = "_image_343hu_11", L = "_hidden_343hu_20", P = "_errorOverlay_343hu_25", U = "_pendingOverlay_343hu_26", n = {
  container: x,
  image: G,
  hidden: L,
  errorOverlay: P,
  pendingOverlay: U
}, e = {
  IDLE: 0,
  PENDING: 1,
  SUCCESS: 2,
  ERROR: 3
}, A = N(
  ({
    src: s,
    alt: i,
    aspectRatio: d,
    onLoad: l,
    onError: m,
    sizes: z,
    srcSet: $,
    objectFit: R = "contain",
    lazy: E = !0,
    ...g
  }, f) => {
    const [o, r] = v(e.IDLE), a = I(null), h = O(f, a);
    C(() => {
      if (!a.current) {
        r(e.PENDING);
        return;
      }
      if (!s) {
        r(e.ERROR);
        return;
      }
      r(e.PENDING), a.current.complete && a.current.decode().then(() => r(e.SUCCESS)).catch(() => r(e.ERROR));
    }, [s]);
    const u = (c) => {
      r(e.SUCCESS), l?.(c);
    }, S = (c) => {
      r(e.ERROR), m?.(c);
    }, _ = y(n.image, {
      [n.hidden]: o !== e.SUCCESS
    });
    return /* @__PURE__ */ p("div", { className: n.container, style: { aspectRatio: d }, "data-component": "Image", children: [
      o === e.PENDING && /* @__PURE__ */ t("div", { className: n.pendingOverlay }),
      o === e.ERROR && /* @__PURE__ */ t("div", { className: n.errorOverlay, role: "img", "aria-label": i, children: /* @__PURE__ */ t(D, { icon: "photo-picture", size: "sm", color: "moon" }) }),
      /* @__PURE__ */ t(
        "img",
        {
          ...g,
          src: s,
          alt: i,
          "aria-hidden": o === e.ERROR,
          loading: E ? "lazy" : "eager",
          decoding: "async",
          onLoad: u,
          onError: S,
          style: { objectFit: R },
          className: _,
          ref: h
        }
      )
    ] });
  }
);
export {
  A as Image
};
//# sourceMappingURL=index.js.map
